"use client";

import React, { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Try to capture the error with Sentry, but don't fail if Sentry is not available
		try {
			// Dynamic import to avoid build-time errors
			import("@sentry/nextjs")
				.then((Sentry) => {
					Sentry.captureException(error);
				})
				.catch((err) => {
					console.error("Failed to capture error with Sentry:", err);
				});
		} catch (e) {
			console.error("Error capturing exception:", e);
		}
	}, [error]);

	return (
		<html lang="es">
			<body>
				<h2>Something went wrong!</h2>
				<button type="button" onClick={() => reset()}>
					Try again
				</button>
			</body>
		</html>
	);
}
